module.exports = __webpack_public_path__ + "static/media/demoCreate.ee389d79.PNG";